<mg-button
  [disabled]="disabled"
  [active]="active"
  [type]="_type"
  [attr.color]="color"
  [disableRipple]="false">
  <ng-content></ng-content>
</mg-button>
